import script from "./ButtonGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonGroup.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonGroup.vue?vue&type=style&index=0&id=3551ca43&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3551ca43"]])

export default __exports__